import {Component, Input} from '@angular/core';
import {NgIf} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {IconComponent} from '@adnova/jf-ng-components';
import {Activity} from '../../../interfaces/activity.interface';

@Component({
  selector: 'app-activity',
  templateUrl: './activity.component.html',
  styleUrls: ['./activity.component.scss'],
  standalone: true,
  imports: [NgIf, MatProgressSpinnerModule, IconComponent],
})
export class ActivityComponent {
  @Input()
  value!: Activity;

  constructor() {}
}
